import { combineReducers } from 'redux';
import { statsLeadersRootSaga } from './stats-leaders/sagas';
import { glossaryRootSaga } from './glossary/sagas';
import { statsLeadersReducer } from './stats-leaders/reducer';
import { statsGlossaryReducer } from './glossary/reducer';

const sagas = [ statsLeadersRootSaga, glossaryRootSaga ];
const rootReducer = combineReducers( { statsLeaders: statsLeadersReducer, glossary: statsGlossaryReducer } );

// @ts-expect-error
if ( window.PULSE.app.redux ) {
    // @ts-expect-error
    window.PULSE.app.redux.sagas.statspro.root = sagas;
    // @ts-expect-error
    window.PULSE.app.redux.reducers.statspro.root = rootReducer;
} else {
    // @ts-expect-error
    window.PULSE.app.redux = {
        reducers: {
            statspro: {
                root: rootReducer
            }
        },
        sagas: {
            statspro: {
                root: sagas
            }
        }
    };
}
